import { baseDays, FilterValue, formatDateToYMD } from "../../../../components/types/types";
import { SearchMiniResto } from "../../../../context/RestaurantContext";
import { toMinutesMini } from "../../SearchPage/hookSearchPage";

export type OpeningService =
    | "lunch"
    | "dinner"
    | "lunch_tomorrow"
    | "dinner_tomorrow"
    | "now";

const addDaysMini = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};
const normalizeRange = (startRaw: unknown,endRaw: unknown): [number, number] | null => {
    const start = toMinutesMini(startRaw as string);
    let end = toMinutesMini(endRaw as string);
    if (!Number.isFinite(start) || !Number.isFinite(end)) return null
    if (end <= start) end += 24 * 60;

    return [start, end];
};
const getMiniRestoRangesForDate = ( restaurant: SearchMiniResto, date: Date): Array<[number, number]> => {
    const ymd = formatDateToYMD(date);
    const dayKey = baseDays[date.getDay()];

    const special = restaurant.special_date?.[ymd];
    if (special) {
        const isOpen = special[0];
        if (isOpen !== true) return [];
        const slots = special[1];
        if (!Array.isArray(slots)) return [];

        return slots
            .map((slot) =>
                normalizeRange(slot?.[0], slot?.[1])
            )
            .filter(
                (range): range is [number, number] => range !== null
            );
    }
    const schedule = restaurant.schedule?.[dayKey];
    if (!Array.isArray(schedule)) return [];

    return schedule
        .map((slot) =>
            normalizeRange(slot?.[0], slot?.[1])
        )
        .filter(
            (range): range is [number, number] =>
                range !== null
        );
};

export const isMiniRestoStillValidForService = (
    restaurant: SearchMiniResto,
    service: OpeningService
): boolean => {
    const now = new Date();
    const targetDate = service === "lunch_tomorrow" || service === "dinner_tomorrow"     ? addDaysMini(now, 1)     : now;
    const ranges = getMiniRestoRangesForDate(restaurant,targetDate);
    if (ranges.length === 0) return false;

    const currentMinutes =
        now.getHours() * 60 + now.getMinutes();
    if (service === "now") {
        const tolerance = 15;
        return ranges.some(([start, end]) => {
            let adjustedStart = start - tolerance;
            if (adjustedStart < 0) adjustedStart += 24 * 60;

            return (
                adjustedStart <= currentMinutes &&
                currentMinutes <= end
            );
        });
    }
    const targetMinutes = service === "lunch" || service === "lunch_tomorrow" ? toMinutesMini("12h30") : toMinutesMini("20h00");

    const matchingRange = ranges.find(([start, end]) => {return (start <= targetMinutes &&targetMinutes <= end)});
    if (!matchingRange) return false;
    if (service === "lunch_tomorrow" ||service === "dinner_tomorrow") return true;

    const [, serviceEnd] = matchingRange;
    return currentMinutes <= serviceEnd;
};
export const getOpeningServiceFromFilters = (
    filters: FilterValue[]
): OpeningService | null => {
    if (filters.includes("Ouvert ce midi")) return "lunch";

    if (filters.includes("Ouvert ce soir")) return "dinner";

    if (filters.includes("Ouvert demain midi")) return "lunch_tomorrow";

    if (filters.includes("Ouvert demain soir")) return "dinner_tomorrow";

    if (filters.includes("Ouvert maintenant")) return "now";

    return null;
};